export default __webpack_public_path__ + "static/media/ProximaNova-Regular.db098dc7.ttf";